import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=5021c540&"
import script from "./MainNavbar.vue?vue&type=script&lang=js&"
export * from "./MainNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.2_cache-loader@4.1.0_webpack@4.28.4_supports-color@6.1.0___css-loader@3_7d6ac29872945af8d84571788ffddadf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports